/**
 * TrendMart Client-Side Wishlist Manager (localStorage)
 */
document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY = 'trendmart_wishlist';
  const countBadges = document.querySelectorAll('[data-wishlist-count]');

  const getWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  };

  const saveWishlist = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      console.error('Failed to save wishlist:', e);
    }
  };

  const updateBadges = (count) => {
    const num = parseInt(count, 10) || 0;
    countBadges.forEach(badge => {
      badge.textContent = num;
      badge.setAttribute('data-wishlist-count', num);
      if (num > 0) {
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });
  };

  const syncButtons = () => {
    const list = getWishlist();
    const ids = list.map(i => String(i.id));

    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const prodId = btn.getAttribute('data-product-id');
      if (ids.includes(String(prodId))) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  };

  // Initial Sync
  const initialWishlist = getWishlist();
  updateBadges(initialWishlist.length);
  syncButtons();

  // Click delegation
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;

    const id = btn.getAttribute('data-product-id');
    const handle = btn.getAttribute('data-product-handle');
    const title = btn.getAttribute('data-product-title');
    const price = btn.getAttribute('data-product-price');
    const image = btn.getAttribute('data-product-image');
    const url = btn.getAttribute('data-product-url');

    let list = getWishlist();
    const existingIndex = list.findIndex(i => String(i.id) === String(id));

    if (existingIndex > -1) {
      list.splice(existingIndex, 1);
      btn.classList.remove('is-active');
    } else {
      list.push({ id, handle, title, price, image, url });
      btn.classList.add('is-active');
    }

    saveWishlist(list);
    updateBadges(list.length);
    syncButtons();

    // Re-render if on wishlist page
    renderWishlistPage();
  });

  // Render on dedicated Wishlist Page
  const renderWishlistPage = () => {
    const pageContainer = document.querySelector('[data-wishlist-page-container]');
    if (!pageContainer) return;

    const list = getWishlist();
    if (list.length === 0) {
      pageContainer.innerHTML = `
        <div style="background:#fff;border:1px solid var(--color-border);border-radius:var(--radius-card);padding:60px 20px;text-align:center;">
          <div style="width:60px;height:60px;margin:0 auto 16px;background:#EFF6FF;border-radius:var(--radius-pill);display:flex;align-items:center;justify-content:center;color:var(--color-primary);">
            <svg class="tm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
          </div>
          <h2 style="font-size:1.3rem;font-weight:700;margin-bottom:8px;">Your Wishlist is Empty</h2>
          <p style="color:var(--color-text-muted);margin-bottom:20px;">Save your favorite items so you can easily find them later!</p>
          <a href="/collections/all" class="tm-btn tm-btn--primary">Start Browsing &rarr;</a>
        </div>
      `;
      return;
    }

    pageContainer.innerHTML = `
      <div class="tm-product-grid" style="grid-template-columns:repeat(4, 1fr);">
        ${list.map(item => `
          <div class="tm-product-card">
            <div class="tm-product-card__media-wrap">
              <a href="${item.url}">
                <img src="${item.image}" alt="${item.title}" loading="lazy" width="300" height="300">
              </a>
            </div>
            <h3 class="tm-product-card__title"><a href="${item.url}">${item.title}</a></h3>
            <div class="tm-price-box"><span class="tm-price__current">${item.price}</span></div>
            <div style="display:flex;gap:8px;margin-top:auto;">
              <a href="${item.url}" class="tm-btn tm-btn--sm tm-btn--primary" style="flex:1;">View Product</a>
              <button type="button" class="tm-btn tm-btn--sm tm-btn--outline" data-wishlist-toggle data-product-id="${item.id}">Remove</button>
            </div>
          </div>
        `).join('')}
      </div>
    `;
  };

  renderWishlistPage();
});
